import React from 'react';

// Reusable OnBrand geometric background motif (interlocking circle arcs).
// Original to OnBrand: curved geometry only, no square grids. Sits behind content,
// pointer-events disabled, faded via a CSS mask so it dissolves into white space.
// Vary `size` (arc scale), `opacity` (subtlety) and `mask` (visible region) per section.
export default function PatternBg({
  size = 140,
  opacity = 0.07,
  mask = 'radial-gradient(120% 120% at 50% 50%, #000 35%, transparent 78%)',
  className = '',
}) {
  return (
    <div
      aria-hidden="true"
      className={`ob-pattern pointer-events-none absolute inset-0 ${className}`}
      style={{
        backgroundSize: `${size}px ${size}px`,
        opacity,
        WebkitMaskImage: mask,
        maskImage: mask,
      }}
    />
  );
}
